import type { SubscriptionPackage, UserSubscription } from '@/types/domain'

type RecurringLike = {
  billing_mode?: 'payment' | 'subscription' | null
  max_sessions_per_week: number | null
}

export function isRecurringPackage(pkg: Pick<SubscriptionPackage, 'billing_mode'>): boolean {
  return pkg.billing_mode === 'subscription'
}

export function isRecurringSubscription(subscription: UserSubscription | null | undefined): boolean {
  return subscription?.billing_mode === 'subscription'
}

export function isUnlimitedAllowance(value: RecurringLike): boolean {
  return value.billing_mode === 'subscription' && value.max_sessions_per_week == null
}

export function formatWeeklyAllowance(value: RecurringLike): string {
  if (isUnlimitedAllowance(value)) {
    return 'Unbegrenzte Kurse pro Woche'
  }

  const count = value.max_sessions_per_week ?? 0
  return `Max. ${count} ${count === 1 ? 'Kurs' : 'Kurse'} pro Woche`
}
